<template>
  <div>
    <h3 class="text-white text-lg font-semibold mb-4">{{ tx.titulo }}</h3>
    <ul class="space-y-2">
      <li v-for="link in links" :key="link.href">
        <a href="#" @click.prevent="handleClick(link.href)" class="hover:text-white transition-colors">
          {{ link.text }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import { computed } from 'vue'
import { useTextos } from '../../i18n/idioma'

const router = useRouter()

const tx = useTextos({
  pt: { titulo: 'Links Rápidos', agentes: 'Agentes', precos: 'Preços', faq: 'FAQ' },
  en: { titulo: 'Quick Links', agentes: 'Agents', precos: 'Pricing', faq: 'FAQ' },
  es: { titulo: 'Enlaces Rápidos', agentes: 'Agentes', precos: 'Precios', faq: 'Preguntas' },
})

const links = computed(() => [
  { href: '#agents', text: tx.value.agentes },
  { href: '#pricing', text: tx.value.precos },
  { href: '#faq', text: tx.value.faq }
])

function handleClick(href: string) {
  const targetId = href.replace('#', '')

  if (router.currentRoute.value.path !== '/') {
    router.push({ path: '/', hash: href }).then(() => {
      setTimeout(() => {
        history.replaceState(null, '', '/')
      }, 500) //
    })
  } else {
    const targetElement = document.getElementById(targetId)
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: 'smooth' })
    }
  }
}
</script>